const viewportPadding = 20

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max)
}

function getDialogElements(el) {
  return {
    dialogHeaderEl: el.querySelector('.el-dialog__header'),
    dragDom: el.querySelector('.el-dialog')
  }
}

function getDialogVm(vnode) {
  return vnode.componentInstance || vnode.child
}

function getVisibleState(vnode) {
  return Boolean(getDialogVm(vnode) && getDialogVm(vnode).visible)
}

function normalizeOptions(binding) {
  if (binding && typeof binding.value === 'object' && binding.value !== null) {
    return binding.value
  }
  return {
    center: Boolean(binding && binding.value)
  }
}

function getDragBounds(dragDom, dialogHeaderEl) {
  const screenWidth = document.documentElement.clientWidth
  const screenHeight = document.documentElement.clientHeight
  const minLeft = viewportPadding
  const maxLeft = Math.max(screenWidth - dragDom.offsetWidth - viewportPadding, minLeft)
  const minTop = viewportPadding
  const maxTop = Math.max(screenHeight - dialogHeaderEl.offsetHeight - viewportPadding, minTop)

  return {
    screenWidth,
    screenHeight,
    minLeft,
    maxLeft,
    minTop,
    maxTop
  }
}

function initDialogPosition(el) {
  const { dialogHeaderEl, dragDom } = getDialogElements(el)

  if (!dialogHeaderEl || !dragDom || !dragDom.offsetWidth) {
    return
  }

  const options = el.__dragDialogOptions || {}
  const bounds = getDragBounds(dragDom, dialogHeaderEl)
  const computedStyle = window.getComputedStyle(dragDom)
  const defaultTop = parseFloat(computedStyle.marginTop) || bounds.minTop
  const centeredLeft = (bounds.screenWidth - dragDom.offsetWidth) / 2
  const centeredTop = (bounds.screenHeight - dragDom.offsetHeight) / 2
  const initialTop = options.center ? centeredTop : defaultTop

  dragDom.style.position = 'fixed'
  dragDom.style.margin = '0'
  dragDom.style.left = `${clamp(centeredLeft, bounds.minLeft, bounds.maxLeft)}px`
  dragDom.style.top = `${clamp(initialTop, bounds.minTop, bounds.maxTop)}px`
  dragDom.style.right = 'auto'
  dragDom.style.bottom = 'auto'
}

function syncDialogState(el, binding, vnode) {
  el.__dragDialogOptions = normalizeOptions(binding)
  el.__dragDialogVm = getDialogVm(vnode)

  const isVisible = getVisibleState(vnode)
  const wasVisible = el.__dragDialogVisible
  el.__dragDialogVisible = isVisible

  if (isVisible && !wasVisible) {
    requestAnimationFrame(() => {
      initDialogPosition(el)
    })
  }
}

export default {
  inserted(el, binding, vnode) {
    const { dialogHeaderEl, dragDom } = getDialogElements(el)

    if (!dialogHeaderEl || !dragDom) {
      return
    }

    dialogHeaderEl.style.cursor = 'move'
    dialogHeaderEl.onmousedown = (e) => {
      const bounds = getDragBounds(dragDom, dialogHeaderEl)
      const startLeft = parseFloat(dragDom.style.left) || dragDom.getBoundingClientRect().left
      const startTop = parseFloat(dragDom.style.top) || dragDom.getBoundingClientRect().top
      const startX = e.clientX
      const startY = e.clientY

      const onMouseMove = (moveEvent) => {
        const left = clamp(startLeft + moveEvent.clientX - startX, bounds.minLeft, bounds.maxLeft)
        const top = clamp(startTop + moveEvent.clientY - startY, bounds.minTop, bounds.maxTop)

        dragDom.style.left = `${left}px`
        dragDom.style.top = `${top}px`

        if (el.__dragDialogVm && el.__dragDialogVm.$emit) {
          el.__dragDialogVm.$emit('dragDialog')
        }
      }

      const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove)
        document.removeEventListener('mouseup', onMouseUp)
      }

      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseup', onMouseUp)
      e.preventDefault()
    }

    syncDialogState(el, binding, vnode)
  },
  componentUpdated(el, binding, vnode) {
    syncDialogState(el, binding, vnode)
  },
  unbind(el) {
    const { dialogHeaderEl } = getDialogElements(el)

    if (dialogHeaderEl) {
      dialogHeaderEl.onmousedown = null
    }

    delete el.__dragDialogOptions
    delete el.__dragDialogVisible
    delete el.__dragDialogVm
  }
}
